import Vue from 'vue';
import App from './App.vue';
import loader from '@/util/loader';
import router from './router';
import store from './store';
import dict from './util/dict';
import './index.scss';
import './styles/scrollbar.scss';
import '@/assets/iconfont/iconfont.css';

import iview from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(iview);
Vue.use(loader);
Vue.use(dict);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

if ('fontDisplay' in document.body.style) document.body.classList.add('app-support-font-display'); else document.body.classList.add('app-not-support-font-display');
if ('fonts' in document) document.fonts.ready.then(() => document.body.classList.add('app-fonts-loaded'));
